// CalculatorApp.tsx
import React, { useState } from 'react';
import CalculatorButton from './CalculatorButton';

const CalculatorApp: React.FC = () => {
  const [prevInput, setPrevInput] = useState('');
  const [input, setInput] = useState('');
  const [operation, setOperation] = useState('');

  const handleDigitClick = (digit: string) => {
    setInput((input: string) => input + digit);
  };

  const handleOperatorClick = (operator: string) => {
    if (input !== '') {
      setPrevInput(input);
      setOperation(operator);
      setInput('');
    }
  };

  const handleClear = () => {
    setInput('');
    setOperation('');
  };

  const handleEquals = async () => {
    if (input !== '' && operation !== '') {
      // let endpoints = new Map<string, string>([
      //   ['+', 'add'],
      //   ['-', 'add'],
      //   ['*', 'add'],
      //   ['/', 'add'],
      // ])
      // const response = await fetch(`http://calculator-:8080/${endpoints.get(operation)}`, {
      //     method: 'post',
      //     headers: {'Content-Type':'application/json'},
      //     body: JSON.stringify([prevInput, input])
      //   }
      // );
      // const result = await response.json();

      // setInput(result.get('result'));
      let operations = new Map<string, (o1: number, o2: number)=> number >([
        ['+', (o1: number, o2: number) => {return o1 + o2} ],
        ['-', (o1: number, o2: number) => {return o1 - o2} ],
        ['*', (o1: number, o2: number) => {return o1 * o2} ],
        ['/', (o1: number, o2: number) => {return o1 / o2} ],
      ])
      let op = operations.get(operation);
      let op1: number = +prevInput;
      let op2: number = +input;
      let res = 0;
      if (op) {(res = op(op1, op2))};
      setInput(res.toString())
      setOperation('');
    }
  };

  return (
    <div>
      <div>
        <input type="text" value={input} readOnly />
      </div>
      <div>
        <CalculatorButton label="1" onClick={() => handleDigitClick('1')} />
        <CalculatorButton label="2" onClick={() => handleDigitClick('2')} />
        <CalculatorButton label="3" onClick={() => handleDigitClick('3')} />
        <CalculatorButton label="+" onClick={() => handleOperatorClick('+')} />
      </div>
      <div>
        <CalculatorButton label="4" onClick={() => handleDigitClick('4')} />
        <CalculatorButton label="5" onClick={() => handleDigitClick('5')} />
        <CalculatorButton label="6" onClick={() => handleDigitClick('6')} />
        <CalculatorButton label="-" onClick={() => handleOperatorClick('-')} />
      </div>
      <div>
        <CalculatorButton label="7" onClick={() => handleDigitClick('7')} />
        <CalculatorButton label="8" onClick={() => handleDigitClick('8')} />
        <CalculatorButton label="9" onClick={() => handleDigitClick('9')} />
        <CalculatorButton label="*" onClick={() => handleOperatorClick('*')} />
      </div>
      <div>
        <CalculatorButton label="C" onClick={handleClear} />
        <CalculatorButton label="0" onClick={() => handleDigitClick('0')} />
        <CalculatorButton label="=" onClick={handleEquals} />
        <CalculatorButton label="/" onClick={() => handleOperatorClick('/')} />
      </div>
    </div>
  );
};

export default CalculatorApp;
